import aeng from '@/components/auth_engine'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
	mixins: [aeng],
	methods: {
		// return promise
		getHubspotUser (vid) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.get(
				'https://utils.yetvpn.com/vpn/hspot/user',
				{
					emulateJSON: true,
					params: {
						vid: vid
					},
					headers: requestHeaders
				}
			)
		},
		// return promise
		updateHubspotUser (vid, data) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.put(
				'https://utils.yetvpn.com/vpn/hspot/user',
				{
					vid: vid,
					data: data
				},
				{
					headers: requestHeaders
				}
			)
		},
		// return promise
		createHubspotUser (data) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.post(
				'https://utils.yetvpn.com/vpn/hspot/user',
				data,
				{
					headers: requestHeaders
				}
			)
		},
		// return string
		generateSecureString (len) {
			return Array(len)
				.fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$')
				.map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * (x.length + 1))])
				.join('');
		},
		saveUser (user) {
			return this.appdb.collection('users').doc(user.email).set(user)
		},
		updateUser (user, update) {
			return this.appdb.collection('users').doc(user.email).set(update)
		},
		addUserOrder (user, order) {
			return this.appdb.collection('users').doc(user.email).collection('orders').add(order);
		},
		addUserGrants (user, grants) {
			return this.appdb.collection('users').doc(user.email).collection('grants').add(grants);
		},
		updateUserPreferences: async (user, preferences) => {
			const snapshot = await this.appdb.collection('users').doc(user.email).collection('preferences').get();
			snapshot.docs[0].set(preferences);
			this.$store.dispatch('setUserPreferences');
		},
		storeCredentials (login, password) {
			if (window.PasswordCredential) {
				let c = new PasswordCredential({
					id: login,
					password: password
				});
				return navigator.credentials.store(c);
			}
		},
		storeTransaction(user, transaction) {
			return this.appdb.collection('users').doc(user.email).collection('transactions').add(transaction);
		},
		dataLayerEnrich: function(e,p) {
            let dataLayer = window.dataLayer || [];
            let load = {
                'event': e,
                'eventData': p
            };
            dataLayer.push(load)
        }
	}
}